<template>
    <div>
        <div class="title">
            <img :src="titleButterflyImg">
            <div class="article-category"><span>{{wzzl.title}}</span></div>
            <img :src="titleButterflyImg">
        </div>
    </div>
</template>

<script>
	export default {
		name: "EiArticleCategory",
		data() {
			return {
				titleButterflyImg: '/upload/homeBlock/1/public-icon3.png',
				wzzl: {
					title: '近期资讯'
				}
			}
		},
		created() {

		}
	}
</script>

<style scoped lang="scss">
    .title {
        width: 80%;
        margin: 20px auto 0;
        height: 50px;
        text-align: center;

        img:first-child {
            width: 25px;
            margin-right: 20px;
            vertical-align: middle;
        }

        img:last-child {
            width: 25px;
            margin-left: 20px;
            vertical-align: middle;
            transform: scaleX(-1);
        }

        .article-category {
            display: inline-block;
            font-size: 28px;
            vertical-align: middle;
            line-height: 50px;
        }
    }
</style>
